import React from 'react';
import { toast } from 'react-toastify';
import { httpGet } from '../../HttpRequestHandling/httpRequestHandler';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Zoom from '@mui/material/Zoom';
import EnhancedDataGrid from '../Common/EnhancedDataGrid';
import Checkbox from '@mui/material/Checkbox';
import { getDisplayName } from '../Common/Utilities';
import { isNewUi } from '../../redesign/uiMode';
import { LOOKUP_CANCEL, lookupDialogProps } from '../../redesign/shell/lookupCancel';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Zoom in={true} ref={ref} {...props} />;
});

export class PayTo extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            columns: [],
            inProgress: false,
            selectedRow: null,
            resetSelection: false
        };

        this.fetchPayToData = this.fetchPayToData.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleCheckboxClick = this.handleCheckboxClick.bind(this);
        this.renderCheckbox = this.renderCheckbox.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (this.props.info.openDialog && !this.state.resetSelection) {
            this.setState({ selectedRow: null, resetSelection: true });
        }
        if (this.props.info.openDialog && !prevProps.info.openDialog) {
            this.setState({ inProgress: true });
            this.fetchPayToData();
            this.props.info.inProgress(true);
        }
        if (!this.props.info.openDialog && prevProps.info.openDialog) {
            this.setState({ resetSelection: false });
        }
    }

    fetchPayToData() {
        httpGet('/api/setup/payto')
            .then((response) => {
                const { records } = response.data;

                this.setState({
                    data: records || [],
                    columns: [
                        {
                            headerName: getDisplayName('site') + ' Id',
                            field: 'siteId',
                            flex: 0.7,
                            editable: true,
                        },
                        {
                            headerName: getDisplayName('site') + ' Name',
                            field: 'siteName',
                            flex: 1,
                            editable: true,
                        }
                    ],
                    columnVisibilityModel: {
                        companyCode: false
                    },
                    inProgress: false,
                });

                this.props.info.inProgress(false);
            })
            .catch((error) => {
                toast.error('Failed to fetch data');
                this.setState({ inProgress: false });
                this.props.info.inProgress(false);
            });
    }

    handleClose() {
        if (this.props.onClose) {
            this.props.onClose(null, this.state.selectedRow);
        }
    }

    // New UI: close without applying (Cancel, ✕ and Escape).
    handleCancel = (event) => {
        if (this.props.onClose) {
            this.props.onClose(event || null, LOOKUP_CANCEL);
        }
    }

    handleCheckboxClick(event, row) {
        this.setState({ selectedRow: row });
    }

    renderCheckbox(params) {
        return (
            <Checkbox
                color="default"
                checked={this.state.selectedRow && this.state.selectedRow.siteId === params.row.siteId}
                onChange={(event) => this.handleCheckboxClick(event, params.row)}
            />
        );
    }

    render() {
        const { openDialog } = this.props.info;
        const { data, columns, columnVisibilityModel } = this.state;
        const newUi = isNewUi();

        return (
            <Dialog open={openDialog} TransitionComponent={Transition} fullWidth maxWidth="lg" {...lookupDialogProps(newUi)}>
                <DialogTitle>{`Select ${getDisplayName('site')}`}</DialogTitle>
                <DialogContent>
                    <div style={{ display: 'block', overflow: 'auto', width: '100%' }}>
                        <EnhancedDataGrid
                            rows={data}
                            columns={[
                                {
                                    headerName: '',
                                    field: 'select',
                                    width: 50,
                                    renderCell: this.renderCheckbox,
                                },
                                ...columns
                            ]}
                            columnVisibilityModel={columnVisibilityModel}
                            pageSize={10}
                            pagination
                            disableSelectionOnClick
                            getRowId={(row) => `${row.companyCode}-${row.siteId}`}
                        />
                    </div>
                </DialogContent>
                <DialogActions>
                    {newUi ? <Button onClick={this.handleCancel} data-apw2-dismiss="true">Cancel</Button> : null}
                    <Button onClick={this.handleClose} color="primary">
                        {newUi && this.state.selectedRow ? 'Select' : 'Close'}
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}
